import { APPLICATION_ID } from '@hrms/common/constant/global';
import { getCookie } from '../cookies/cookieManager';

export const getUserProfile = () => {
  if (typeof window !== 'undefined') {
    const email = getCookie(`${APPLICATION_ID}_EMAIL`);
    if (email) {
      const profile = { email };
      return profile;
    }
  }
  return undefined;
};
